import { signal } from '@preact/signals-react';

export const publicPath = signal(import.meta.env.BASE_URL ?? '/');
